import { render } from "./ChatFlutuante.vue?vue&type=template&id=efb83b02&scoped=true"
import script from "./ChatFlutuante.vue?vue&type=script&lang=js"
export * from "./ChatFlutuante.vue?vue&type=script&lang=js"

import "./ChatFlutuante.vue?vue&type=style&index=0&id=efb83b02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efb83b02"]])

export default __exports__